
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/inner-engineering/register/thankyou",
      function () {
        return require("private-next-pages/[region]/[language]/inner-engineering/register/thankyou/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/inner-engineering/register/thankyou"])
      });
    }
  